<template>
    <a-layout class="layout-shell" data-cy="main-layout-wrapper">
        <navbar />

        <a-layout class="layout-body" data-cy="main-layout">
            <sidebar />

            <a-layout-content class="layout-main-area" data-cy="main-layout-content">
                <slot />
            </a-layout-content>
        </a-layout>

        <spinner-modal />
    </a-layout>
</template>

<script>
import Navbar from '@/components/layout/Navbar';
import Sidebar from '@/components/layout/Sidebar';
import SpinnerModal from '@/components/common/SpinnerModal';

export default {
    components: {
        Navbar,
        Sidebar,
        SpinnerModal
    }
};
</script>
